import { render, staticRenderFns } from "./KaiCan.vue?vue&type=template&id=50e1a1c0&scoped=true"
import script from "./KaiCan.vue?vue&type=script&lang=js"
export * from "./KaiCan.vue?vue&type=script&lang=js"
import style0 from "./KaiCan.vue?vue&type=style&index=0&id=50e1a1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1a1c0",
  null
  
)

export default component.exports